import { AppBar, Grid, Toolbar, Typography } from "@mui/material";
import React from "react";
import { InterestsPanel } from "./InterestsPanel";
import { SkillsPanel } from "./SkillsPanel";
import { StylesPanel } from "./StylesPanel";

const PanelGroup = ({
  isOnPrintMode,
  job,
  candidateInterestsScore,
  candidateStyles
}) => {
  if (isOnPrintMode) {
    return (
      <Grid
        container
        direction="column"
        justify="space-between"
        spacing={3}
        className="section"
      >
        <Grid item>
          <Grid container>
            <Grid item size>
              <SkillsPanel
                isOnPrintMode={isOnPrintMode}
                skills={job.skills}
                skillScore={job.skillScore}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container direction="row" justify="space-between" spacing={3}>
            <Grid item size={{xs:6}}>
              <InterestsPanel
                isOnPrintMode={isOnPrintMode}
                interestScore={job.interestScore}
                data={Object.keys(job.interests).map(key => ({
                  label: key,
                  value: job.interests[key],
                  candidate: candidateInterestsScore[key.toLowerCase()]
                }))}
              />
            </Grid>
            <Grid item size={{xs:6}}>
              <StylesPanel
                isOnPrintMode={isOnPrintMode}
                stylesScore={job.stylesScore}
                data={Object.keys(job.styles).map(key => {
                  if (key === "Responsiveness to feedback") {
                    return {
                      label: "Responsiveness",
                      value: job.styles[key],
                      candidate: candidateStyles.find(
                        a => a.name === "Responsiveness"
                      ).latest
                    };
                  }
                  return {
                    label: key,
                    value: job.styles[key],
                    candidate: candidateStyles.find(a => a.name === key).latest
                  };
                })}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid container spacing={2} sx={{ height: "100%" }}>
      <Grid item size={{xs:4}} sx={{ height: "100%" }}>
        <SkillsPanel
          isOnPrintMode={isOnPrintMode}
          skills={job.skills}
          skillScore={job.skillScore}
        />
      </Grid>
      <Grid item size={{xs:4}} sx={{ height: "100%" }}>
        <InterestsPanel
          isOnPrintMode={isOnPrintMode}
          interestScore={job.interestScore}
          data={Object.keys(job.interests).map(key => ({
            label: key,
            value: job.interests[key],
            candidate: candidateInterestsScore[key.toLowerCase()]
          }))}
        />
      </Grid>
      <Grid item size={{xs:4}} sx={{ height: "100%" }}>
        <StylesPanel
          isOnPrintMode={isOnPrintMode}
          stylesScore={job.stylesScore}
          data={Object.keys(job.styles).map(key => {
            if (key === "Responsiveness to feedback") {
              return {
                label: "Responsiveness",
                value: job.styles[key],
                candidate: candidateStyles.find(
                  a => a.name === "Responsiveness"
                ).latest
              };
            }
            return {
              label: key,
              value: job.styles[key],
              candidate: candidateStyles.find(a => a.name === key).latest
            };
          })}
        />
      </Grid>
    </Grid>
  );
};

export const JobMatchesGrid = ({
  jobs,
  candidateStyles,
  candidateInterestsScore,
  type,
  isOnPrintMode
}) => {
  if (jobs.length === 0) {
    return null;
  }

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <AppBar
          position="static"
          color="default"
          elevation={0}
          sx={{ mt: 5, mb: 2.5 }}
        >
          <Toolbar
            variant="dense"
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              textAlign: "center",
              border: "1px solid #ddd",
            }}
          >
            <Typography variant="h6" color="inherit">
              Top 5 {type === "normal" ? "Normal" : "Tech"} Job Matches
            </Typography>
          </Toolbar>
        </AppBar>
        
      </Grid>
      <Grid item>
        {jobs.map((job, index) => {
          return (<>
            <Grid
              container
              direction="column"
              spacing={1}
              key={job.sector + index}
            >
              <Grid item className="pagebreak">
              
                <Typography
                  variant="subtitle2"
                  component="h1"
                  sx={{ fontSize: 16, ml: 0, mt: 1.25, mb: 1.25 }}
                >
                  Occupation {index + 1}:{" "}
                  {type === "normal" ? (
                    job.title
                  ) : (
                    <a href={job.url} rel="noopener noreferrer" target="_blank">
                      {job.title}
                    </a>
                  )}{" "}
                  {type === "normal" ? null : <>(Sector: {job.sector})</>}
                </Typography>
              </Grid>

              <Grid
                item
                sx={{
                  height: isOnPrintMode ? "auto" : 360,
                  pageBreakAfter: isOnPrintMode ? "always" : "auto",
                }}
              >
                {
                  <PanelGroup
                    isOnPrintMode={isOnPrintMode}
                    candidateInterestsScore={candidateInterestsScore}
                    candidateStyles={candidateStyles}
                    job={job}
                  />
                }
              </Grid>
              
            </Grid>
            {index %2 === 0 && (<div class="pagebreak" ></div>)}
            
            </>
          );
        })}
      </Grid>
    </Grid>
  );
};
